import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "row", "loadButton", "status", "datalist"]
  static values = { url: String, opcionesRankia: { type: Array, default: [] } }

  // Al abrir la edición cargamos las sugerencias de HubSpot sin que nadie pulse nada. Si no hay
  // Form ID (alta nueva) o la API falla, la columna HubSpot sigue siendo texto libre.
  connect() {
    if (this._hubspotFormId()) this.loadFields()
  }

  add() {
    const index = this.rowTargets.length
    this.containerTarget.insertAdjacentHTML("beforeend", this._rowHTML(index, "", ""))
  }

  remove(event) {
    event.target.closest("[data-campo-mapeos-target='row']").remove()
  }

  // Alimenta el autocompletado y añade una fila por cada campo de HubSpot que aún no esté
  // mapeado. No toca las filas existentes: "cargar" sugiere, no pisa lo ya configurado.
  async loadFields() {
    const formId = this._hubspotFormId()

    if (!formId) {
      this._showStatus("Introduce un HubSpot Form ID primero", true)
      return
    }

    this._setLoading(true)

    try {
      const url = `${this.urlValue}?hubspot_form_id=${encodeURIComponent(formId)}`
      const response = await fetch(url, { headers: { "Accept": "application/json" } })
      const data = await response.json()

      if (!response.ok) {
        this._showStatus(data.error || "Error al cargar campos", true)
        return
      }

      this._fillDatalist(data.campos)

      const yaMapeados = this._camposHubspotMapeados()
      data.campos.filter((campo) => !yaMapeados.includes(campo)).forEach((campo) => {
        this.containerTarget.insertAdjacentHTML("beforeend", this._rowHTML(this.rowTargets.length, "", campo))
      })

      this._showStatus(`${data.campos.length} campos cargados`)
    } catch {
      this._showStatus("Error de conexion con el servidor", true)
    } finally {
      this._setLoading(false)
    }
  }

  _rowHTML(index, rankiaValue, hubspotValue) {
    return `
      <div class="rnk-flex rnk-flex-align-center rnk-margin-y-small" data-campo-mapeos-target="row">
        ${this._rankiaInputHTML(`formulario_hubspot[campo_mapeos][${index}][rankia]`, rankiaValue)}
        <span class="rnk-margin-x-small">&rarr;</span>
        <input type="text" name="formulario_hubspot[campo_mapeos][${index}][hubspot]" value="${hubspotValue}" placeholder="Campo HubSpot" list="campos-hubspot" class="rnk-Forms_Text-small">
        <button type="button" class="rnk-Button-danger" data-action="campo-mapeos#remove">X</button>
      </div>
    `
  }

  // Con opciones (formulario de promoción con formulario de Promociones enlazado) la columna
  // Rankia es un desplegable de `names`; sin ellas, texto libre como en el resto de categorías.
  _rankiaInputHTML(name, value) {
    if (this.opcionesRankiaValue.length === 0) {
      return `<input type="text" name="${name}" value="${value}" placeholder="Campo Rankia"
                     class="rnk-Forms_Text-small">`
    }

    const options = ["", ...this.opcionesRankiaValue].map((campo) => {
      const selected = campo === value ? " selected" : ""
      return `<option value="${campo}"${selected}>${campo || "Campo Rankia"}</option>`
    })
    return `<select name="${name}" class="rnk-Forms_Text-small">${options.join("")}</select>`
  }

  _hubspotFormId() {
    return this.element.closest("form").querySelector("[name*='hubspot_form_id']")?.value?.trim()
  }

  _camposHubspotMapeados() {
    return this.rowTargets.map((row) => row.querySelector("[name$='[hubspot]']").value.trim())
  }

  _fillDatalist(campos) {
    if (!this.hasDatalistTarget) return

    this.datalistTarget.replaceChildren(...campos.map((campo) => {
      const option = document.createElement("option")
      option.value = campo
      return option
    }))
  }

  _setLoading(loading) {
    if (this.hasLoadButtonTarget) {
      this.loadButtonTarget.disabled = loading
      this.loadButtonTarget.textContent = loading ? "Cargando..." : "Cargar campos de HubSpot"
    }
  }

  _showStatus(message, isError = false) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.style.display = "inline"
      this.statusTarget.style.color = isError ? "red" : "green"
    }
  }
}
